import { TextareaConfig } from "../../../organisms/TableData/types";

export const DEFAULT_TEXTAREA_CONFIG: TextareaConfig = {
  minLength: 2,
  maxLength: 255,
};

export const AUTOCOMPLETE_DISABLE_VALUE = "off";
export const MAX_CHAR_COUNT_IN_WORD = 20;
